import React from 'react'
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle
} from 'reactstrap'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const ProjectFilters = ({
  activeFilter = null,
  onFilterChange
}) => {
  const { t } = useTranslation('ProjectsPage')
  const [isOpen, setIsOpen] = React.useState(false)

  const filters = [
    { key: 'failed', label: t('ProjectFilters.failed') },
    { key: 'conflicts', label: t('ProjectFilters.conflicts') },
    { key: 'missing', label: t('ProjectFilters.missing') },
    { key: 'orphans', label: t('ProjectFilters.orphans') }
  ]

  const activeLabel = activeFilter
    ? filters.find((f) => f.key === activeFilter)?.label
    : t('ProjectFilters.all')

  return (
    <Dropdown isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
      <DropdownToggle caret color="light" className="border">
        {activeLabel}
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem
          active={activeFilter === null}
          onClick={() => onFilterChange(null)}
        >
          {t('ProjectFilters.all')}
        </DropdownItem>
        <DropdownItem divider />
        {filters.map((filter) => (
          <DropdownItem
            key={filter.key}
            active={activeFilter === filter.key}
            onClick={() => onFilterChange(filter.key)}
          >
            {filter.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  )
}

ProjectFilters.propTypes = {
  activeFilter: PropTypes.string,
  onFilterChange: PropTypes.func.isRequired
}

export default ProjectFilters
